import { Component } from '@angular/core';
import { CmpsDialogRef } from '@cmps/ng-uikit';

import { TranslationKeyMap } from './auth.i18n';

enum ResetOptions {
    UNSET,
    EMAIL,
    QUESTION,
}

@Component({
    selector: 'cmps-auth-reset',
    templateUrl: './reset.auth.component.html',
})
export class ResetAuthComponent {
    i18n = TranslationKeyMap;
    ResetOptions = ResetOptions;
    opt: number;

    constructor(
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            ResetAuthComponent,
            void
        >,
    ) {
        this.opt = ResetOptions.UNSET;
    }
}
